import { Banner, Button, Loader } from '@kanda-libs/ks-design-library';

import { BUTTON_SMALL_PROPS } from '../CompleteAccountBadge/CompleteAccountBadge-constants';
import {
  BUTTON_LARGE_PROPS,
  CLASS_NAMES,
} from './AccountCompletedBadge-constants';
import Container from './AccountCompletedBadge-container';

const ViewComponent = () => (
  <Container>
    {({ showBanner, onClick, isSubmitting }) =>
      showBanner && (
        <div className="md:mt-10 border rounded-lg border-purple-100">
          <Banner>
            <div className={CLASS_NAMES.container}>
              <div className={CLASS_NAMES.textWrapper}>
                <span className={CLASS_NAMES.title}>
                  Verification in progress
                </span>
                <span className={CLASS_NAMES.subTitle}>
                  You can send this job once verified
                </span>
              </div>
              <div className={CLASS_NAMES.link}>
                <Button.Text onClick={onClick} {...BUTTON_LARGE_PROPS} />
                <Button.Text onClick={onClick} {...BUTTON_SMALL_PROPS} />
              </div>
            </div>
          </Banner>
          <Loader isLoading={isSubmitting} />
        </div>
      )
    }
  </Container>
);

ViewComponent.displayName = 'AccountCompletedBadge-view';

export default ViewComponent;
